var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.896,
    height: 15.487,
    viewBox: "0 0 22.896 15.487",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30542",
    "data-name": "Group 30542",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30261",
    "data-name": "Group 30261",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4232",
    "data-name": "Path 4232",
    d: "M22.05,11.257v2.836A1.731,1.731,0,0,1,20.411,15.9H3.057a1.731,1.731,0,0,1-1.639-1.811V3.45a1.944,1.944,0,0,1,1.84-2.033H20.21A1.944,1.944,0,0,1,22.05,3.45",
    transform: "translate(-1.418 -1.417)",
    fill: "rgba(0,0,0,0)",
    stroke: "#6f6f6f",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4233",
    "data-name": "Path 4233",
    d: "M23.291,12.884a1.74,1.74,0,1,1-1.74-1.74A1.74,1.74,0,0,1,23.291,12.884Z",
    transform: "translate(-14.808 -8.498)",
    fill: "rgba(0,0,0,0)",
    stroke: "#6f6f6f",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4234",
    "data-name": "Path 4234",
    d: "M16.365,28.467,18.4,26.813a1.221,1.221,0,0,1,1.41-.093l1.794,1.1a1.222,1.222,0,0,0,1.671-.385l1.682-2.647a1.222,1.222,0,0,1,2.073.019l2.355,3.857a.782.782,0,0,1-.667,1.19H16.858A.782.782,0,0,1,16.365,28.467Z",
    transform: "translate(-12.088 -18.021)",
    fill: "rgba(0,0,0,0)",
    stroke: "#6f6f6f",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    x2: 3.577,
    transform: "translate(18.819 5.792)",
    fill: "none",
    stroke: "#6f6f6f",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    "data-name": "Line 64",
    y2: 3.577,
    transform: "translate(20.607 4.004)",
    fill: "none",
    stroke: "#6f6f6f",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIcon);
export default __webpack_public_path__ + "static/media/imgIcon.2dfd8060f998055afdb48db107f35a75.svg";
export { ForwardRef as ReactComponent };